import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import { useHistory } from "react-router-dom";
import MyVerticallyCenteredModal from "./MyVerticallyCenteredModal";
import { LocationContext } from "../../../CustomHelper/Helper";
import { useZeroPayment } from "../../../CustomHooks/useZeroPayment";

const RegisterNowPay = ({
  post,
  event_type,
  quantity = 0,
  baseFee = 0,
  fee,
  start_time,
  end_time,
  postRegistration = null,
  notification_id = null,
  greetingId = null,
  freePayment = null
}) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [passwordInput, setPassword] = useState("");
  const [registered, setRegistered] = useState();
  const [verifyUserBuffer, setVerifyUserBuffer] = useState(false);
  const { paymentCount } = useContext(LocationContext);

  const registerData = {
    quantity: quantity,
    event_id: post?.id,
    event_registration_id: postRegistration?.id,
    notification_id: notification_id,
    model_name: event_type,
    fee: fee,
    start_time: start_time,
    end_time: end_time,
    payment_method: "Free-Registaion",
  }
  const { freeRegistration, freeRegBuffer } = useZeroPayment(registerData)


  // console.log('post', post);

  const assignmentRegEndDate = new Date(post?.assignment_reg_end_date?.replace(" ", "T")).getTime();
  const currentTime = new Date().getTime();



  const handleInput = (e) => {
    e.persist();
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {

    setVerifyUserBuffer(true);
    e.preventDefault();
    const data = {
      password: passwordInput,
    };

    if (passwordInput) {

      if (assignmentRegEndDate > currentTime) {
        swal("Warning", "The assignment end date is in the future.", "warning");
        return;
      }

      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios
          .post(`/api/verify_user`, data)
          .then((res) => {
            setVerifyUserBuffer(false);
            if (res.data.status === 200) {
              if (fee != 0) {
                setModalShow(true)
              } else {

                freeRegistration()
              }
              //alert(fee)
              // ;


            } else {
              setPassword("");
              swal("Warning", res.data.message, "warning");
            }
          })
          .catch((err) => {
            setVerifyUserBuffer(false);
          });
      });
    } else {
      setVerifyUserBuffer(false);
      swal("Warning", "Insert Password", "warning");
    }
  };

  useEffect(() => {
    localStorage.getItem("auth_token") &&
    axios
      .get(`api/user/registration_checker/${event_type}/${post.slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          setRegistered(res.data.participant);
        }
      });
  }, [post.slug, event_type]);
  return (
    <>
      {registered ? (
        <div className="">
          <div className="p-5 m-3">
            <div className="text-center">
              {registered.publish_status === 1 ||
                registered.payment_status === 1 ? (
                <button className="btn text-light btn-danger">
                  Already Registered : &nbsp;
                  {moment(registered.created_at).format("LL")}
                </button>
              ) : (
                <button
                  className="btn text-darak btn-warning"
                  onClick={() => setModalShow(true)}
                >
                  Make Your payment
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="">
          <div className="m-3">
            <div className="mt-4 pt-3">
              {event_type === "livechat" ? (
                <>
                  <div className="row py-2">
                    <h5 className="text-light fw-bold col-md-4">
                      Total Fee: {fee}
                    </h5>
                    <h5 className="text-light fw-bold col-md-4">
                      {/* Start: {moment(start_time, "HH:mm::ss").format("h:mm a")} */}
                    </h5>
                    <h5 className="text-light fw-bold col-md-4">
                      {/* End {moment(end_time, "HH:mm::ss").format("h:mm a")} */}
                    </h5>
                  </div>
                </>
              ) : event_type === "qna" ? (
                <>
                  <div className="row py-2">
                    <h5 className="text-light fw-bold col-md-4">
                      Total Fee: {fee}
                    </h5>
                    <h5 className="text-light fw-bold col-md-4">
                      {/* Start: {moment(start_time, "HH:mm::ss").format("h:mm a")} */}
                    </h5>
                    <h5 className="text-light fw-bold col-md-4">
                      {/* End {moment(end_time, "HH:mm::ss").format("h:mm a")} */}
                    </h5>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="row my-3">
                <div className="col-md-6">
                  <h5 className="text-light ">Event Name - {event_type}</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_name")}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <h5 className="text-light">Phone number</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_phone")||''}
                    readOnly
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-md-6">
                  <h5 className="text-light ">Email</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_email")||''}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <h5 className="text-light">Password</h5>
                  <input
                    type="password"
                    className="form-control inputColorBorder text-light"
                    name="password"
                    value={passwordInput}
                    onChange={handleInput}
                    required
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center mt-4">
                <div className="col-md-2">
                  {assignmentRegEndDate > currentTime ? (
                    <>
                      <button
                        disabled
                        className="btn btn-register fw-bold">
                        Register
                      </button>
                    </>

                  ) : (

                    <>
                    <button
                    onClick={handleSubmit}
                    className="btn btn-register fw-bold"
                  >
                    {verifyUserBuffer && (
                      <>
                        <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                      </>
                    )}
                    Register
                  </button>
                  </>
                  )}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        event_id={postRegistration?.id ? postRegistration?.id : post?.id}
        event_registration_id={postRegistration?.id}
        notification_id={notification_id}
        event_type={event_type}
        start_time={start_time}
        end_time={end_time}
        quantity={quantity}
        baseFee={baseFee}
        fee={fee}
        greetingId={greetingId}
        redirectTo="activities"
      />
    </>
  );
};

export default RegisterNowPay;
